import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// Tiny a11y-friendly toast. Uses aria-live to announce to screen readers.
import { createContext, useCallback, useContext, useState } from 'react';
const ToastCtx = createContext({ notify() { } });
export function useToast() { return useContext(ToastCtx); }
export function ToastProvider({ children }) {
    const [toasts, setToasts] = useState([]);
    const notify = useCallback((kind, body) => {
        const id = Math.random().toString(36).slice(2, 9);
        setToasts((t) => [...t, { id, kind, body }]);
        setTimeout(() => setToasts((t) => t.filter(x => x.id !== id)), 5000);
    }, []);
    return (_jsxs(ToastCtx.Provider, { value: { notify }, children: [children, _jsx("div", { role: "status", "aria-live": "polite", "aria-relevant": "additions", className: "fixed bottom-4 right-4 z-[60] flex w-[min(360px,calc(100vw-2rem))] flex-col gap-2", children: toasts.map(t => (_jsx("div", { className: 'rounded-lg px-4 py-3 text-sm shadow-lg ring-1 ' +
                        (t.kind === 'success' ? 'bg-emerald-50 text-emerald-900 ring-emerald-200' :
                            t.kind === 'error' ? 'bg-red-50 text-red-900 ring-red-200' :
                                'bg-white text-slate-900 ring-slate-200'), children: t.body }, t.id))) })] }));
}
